import { Box } from '@mui/material';
import {
    TabbedShowLayoutTabs,
    type TabbedShowLayoutTabsProps,
} from 'react-admin';
import { HorizontalScrollRow } from './HorizontalScrollRow';

/**
 * Tab headers with native horizontal scroll (MUI scrollable Tabs often fail inside nested flex/grid).
 */
export const ScrollableTabbedShowLayoutTabs = (
    props: TabbedShowLayoutTabsProps
) => (
    <HorizontalScrollRow
        ariaLabel="Sections"
        leftAriaLabel="Scroll sections left"
        rightAriaLabel="Scroll sections right"
    >
        <Box
            sx={{
                width: 'max-content',
                minWidth: '100%',
                flexShrink: 0,
            }}
        >
            <TabbedShowLayoutTabs
                scrollButtons={false}
                variant="standard"
                {...props}
                sx={[
                    {
                        minWidth: 0,
                        '& .MuiTabs-scroller': {
                            overflow: 'visible !important',
                        },
                        '& .MuiTabs-flexContainer': {
                            flexWrap: 'nowrap',
                        },
                        '& .MuiTab-root': {
                            flex: '0 0 auto',
                            maxWidth: 'none',
                        },
                    },
                    ...(Array.isArray(props.sx)
                        ? props.sx
                        : props.sx
                          ? [props.sx]
                          : []),
                ]}
            />
        </Box>
    </HorizontalScrollRow>
);
